export default __webpack_public_path__ + "static/media/llm-book.6ebdfdb7.png";